import React from 'react';
import { PageContext } from '../..';
import { VendexInputMeta } from '../../../models/VendexElement';

type Props = {
  id: string;
  data: VendexInputMeta;
};

const VendexInput: React.FC<Props> = ({ id, data }) => {
  const { store } = React.useContext(PageContext);

  React.useEffect(() => {
    if (store.data[data.name] === undefined) {
      store.SET_DATA(`${data.name}, `);
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    store.SET_DATA(`${data.name}, ${e.target.value}`);
  };

  return <input id={id} value={store.data[data.name]} onChange={handleChange} onInput={handleChange} placeholder={data.placeholder ?? ''} data-vendex />;
};

export default VendexInput;
